<template>
    <div class="case-edit">
        <div class="header">
            <div class="go-back" @click="goBack">返回</div>
            <div class="line">|</div>
            <div>添加案例</div>
        </div>
        <!-- 添加成功 -->
        <div v-if="showSubmitSucc" class="submit-succ">
            <div class="icon"></div>
            <div class="content">恭喜成功上传案例</div>
            <div class="btns">
                <veui-button class="detail" @click="toCaseList">查看详情</veui-button>
                <veui-button @click="uploadMore">再传一个</veui-button>
            </div>
        </div>
        <template v-else>
            <section class="case-detail">
                <div class="title">案例详情</div>
                <veui-form
                    ref="form"
                    class="form"
                    :data="formData"
                >
                    <veui-field
                        name="caseTitle"
                        label="案例标题"
                        :rules="[{name: 'required', value: true}]"
                    >
                        <veui-input
                            v-model="formData.caseTitle"
                            class="case-title"
                            placeholder="请输入案例标题"
                            maxlength="40"
                            type="text"
                        />
                    </veui-field>
                    <veui-field
                        name="caseTime"
                        label="案例时间"
                        :rules="[{name: 'required', value: true, message: '请选择'}]"
                    >
                        <veui-date-picker
                            v-model="formData.caseTime"
                            placeholder="请输入案例时间"
                        />
                    </veui-field>
                    <veui-fieldset
                        class="case-mb"
                    >
                        <veui-field
                            name="type"
                            label="为当事人"
                        >
                            <veui-select
                                v-model="formData.type"
                                class="case-select"
                                :options="types"
                            />
                        </veui-field>
                        <veui-field
                            name="money"
                            label=""
                        >
                            经济损失
                            <veui-number-input
                                v-model="formData.money"
                                class="case-money"
                                placeholder="请输入数字"
                                :min="0"
                            />万元
                        </veui-field>
                    </veui-fieldset>
                    <veui-field
                        label="代理律师"
                        name="lawyerName"
                    >
                        <veui-input
                            v-model="formData.lawyerName"
                            placeholder="请输入姓名"
                            disabled
                        />
                    </veui-field>
                    <veui-field
                        label="案例归属法院"
                        name="courtName"
                    >
                        <veui-input
                            v-model="formData.courtName"
                            maxlength="30"
                            placeholder="请输入案例归属法院"
                        />
                    </veui-field>
                    <veui-field
                        name="caseContent"
                        label="案例详情"
                        class="case-content"
                        :rules="[{name: 'required', value: true, message: '请填写案例详情'}]"
                    >
                        <customize-editor
                            ref="editorItem"
                            :quill-id="0"
                            :quill-toolbar="quillToolbar"
                            external-class="case-editor"
                            quill-placeholder="请输入案例内容"
                            :is-default-upload="false"
                            @editor-change="editorChange"
                        >
                        </customize-editor>
                        <div class="editor-text-tip">
                            <span
                                :class="{'error': formData.caseContent && formData.caseContent.length > maxNum}"
                            >{{ formData.caseContent && formData.caseContent.length || 0 }}</span> / {{ maxNum }}
                        </div>
                    </veui-field>
                </veui-form>
            </section>
            <section class="case-submit">
                <veui-button class="btn" @click="handleSubmit">上传</veui-button>
                <veui-button class="btn cancel" @click="goBack">取消</veui-button>
            </section>
        </template>
    </div>
</template>

<script>
// 案例新增页
import {Select, Input, DatePicker, Button, Fieldset, NumberInput, Form, Field} from 'veui';
import CustomizeEditor from '@/components/customize-editor';
import {mapState} from 'vuex';
import {isBoolean} from 'lodash';

const URL = {
    updateLawyerCase: '/bp/case/updatelawyercase',
    addLawyerCase: '/bp/case/addlawyercase',
    getBusinessMember: '/bp/api/business/getlawyerlist'
};

export default {
    name: '',
    components: {
        'veui-button': Button,
        'veui-form': Form,
        'veui-field': Field,
        'veui-input': Input,
        'veui-select': Select,
        'veui-number-input': NumberInput,
        'veui-fieldset': Fieldset,
        'veui-date-picker': DatePicker,
        CustomizeEditor
    },
    data() {
        return {
            formData: {
                // 案例id
                caseId: 0,
                // 案例标题
                caseTitle: '',
                // 案例详情
                caseContent: '',
                // 代理法院
                courtName: '',
                // 类型
                type: null,
                // 金额
                money: null,
                // 案例时间
                caseTime: null,
                // 代理律师
                lawyerName: ''
            },
            types: [
                {
                    label: '挽回',
                    value: '挽回'
                },
                {
                    label: '避免',
                    value: '避免'
                }
            ],
            roles: [
                {
                    label: '原告代理人',
                    value: '原告代理人'
                },
                {
                    label: '被告代理人',
                    value: '被告代理人'
                },
                {
                    label: '代理第三者',
                    value: '代理第三者'
                }
            ],
            quillToolbar: [
                ['bold', 'italic', 'underline'],
                [{header: 1}, {header: 2}, 'blockquote'],
                [{list: 'ordered'}, {list: 'bullet'}],
                [{indent: '-1'}, {indent: '+1'}, {direction: 'rtl'}, {align: []}],
                ['link', 'image']
            ],
            // 归属律师
            lawyerList: [],
            // 提交锁
            isSubmit: false,
            // 最大字数限制
            maxNum: 6000,
            showSubmitSucc: false,
            isAdd: false // 是否点击新建一个
        };
    },
    computed: {
        ...mapState({
            lawyerBusinessInfo: state => state.lawStore.userInfoNew?.law_business_info || {},
            userInfo: state => state.lawStore.userInfoNew?.lawyer_info || {}
        })
    },
    props: {
        caseInfo: {
            type: Object,
            default: () => ({})
        }
    },
    watch: {
        caseInfo: {
            deep: true,
            immediate: true,
            handler(val) {
                if (Object.keys(val).length > 0) {
                    let {case_id, case_title, case_time, lawyer_name, court_name, case_content, case_result} = val;
                    case_time = case_time ? new Date(+case_time * 1000) : null;
                    let type = null;
                    let money = null;
                    if (case_result.length > 2) {
                        type = case_result.slice(0, 2);
                        let moneys = case_result.match(/\d+/g);
                        money = moneys && moneys.length && moneys[0];
                        money = money.length && parseInt(money, 10);
                    }
                    this.formData = {
                        caseId: case_id,
                        caseTitle: case_title,
                        caseTime: case_time,
                        lawyerName: lawyer_name,
                        courtName: court_name,
                        caseContent: case_content,
                        type,
                        money
                    };
                    // 富文本编辑器内容赋值
                    this.setContent(case_content);
                }
            }
        }
    },
    mounted() {
        this.formData.lawyerName = this.userInfo?.name || '';
    },
    methods: {
        goBack() {
            this.$emit('hideCaseEdit');
        },
        /**
         * 富文本编辑器-输入
         * @param {object} 文本内容
         */

        editorChange(args = {}) {
            let {innerHTML = ''} = args;
            this.$set(this.formData, 'caseContent', innerHTML);
        },

        /**
         * 点击再传一个
         */

        uploadMore() {
            this.showSubmitSucc = false;
            this.isAdd = true;
            // 清空表单
            this.$nextTick(() => {
                this.reset();
            });
        },

        /**
         * 跳转案例列表页
         */

        toCaseList() {
            this.$emit('toCaseList');
        },

        handleSubmit() {
            if (this.isSubmit) {
                return;
            }
            this.isSubmit = true;
            this.$refs.form.validate().then(flag => {
                this.isSubmit = false;
                if (isBoolean(flag) && flag) {
                    if (this.formData.caseContent?.length > this.maxNum) {
                        let toast = {
                            content: '当前【案例详情】部分，您输入的字数或上传的图片过多，请调整后提交',
                            duration: 2
                        };
                        this.$Message.info(toast);
                        return;
                    }
                    this.submitCase();
                }
                else {
                    let toast = {
                        content: '有必填字段未填写/填写不符合规范，请完善后再保存',
                        duration: 1
                    };
                    this.$Message.info(toast);
                }
            }).catch(err => {
                this.isSubmit = false;
            });
        },

        /**
         * 提交案例
         */

        submitCase() {
            if (this.isSubmit) {
                return;
            }
            this.isSubmit = true;
            let isEdit = !this.isAdd && this.caseInfo && Object.keys(this.caseInfo).length;
            const submitUrl = isEdit ? URL.updateLawyerCase : URL.addLawyerCase;
            let {
                caseTitle,
                caseId = '',
                type,
                money,
                caseTime,
                lawyerName,
                courtName,
                caseContent
            } = this.formData;

            // caseResult-信息处理
            let caseResult = '';
            if (type && type.length > 0 && money) {
                caseResult = `${type}损失${money}万元`;
            }
            // 案例时间处理
            caseTime = caseTime && (caseTime.getTime() / 1000);
            const form = new FormData();
            form.append('caseTitle', caseTitle);
            caseId && form.append('caseID', caseId);
            form.append('caseResult', caseResult);
            form.append('caseContent', caseContent);
            form.append('caseTime', caseTime);
            form.append('lawyerName', lawyerName);
            form.append('courtName', courtName);
            form.append('add_from', 1);

            this.$http({
                method: 'post',
                url: submitUrl,
                data: form
            }).then(res => {
                this.isSubmit = false;
                if (res && +res.code === 0) {
                    this.$toast.success(`案例${isEdit ? '修改' : '提交'}成功，请耐心等待审核~`);
                    this.showSubmitSucc = true;
                    // 提交成功时，弹窗关闭需要时间，不再解锁，下次开启弹窗时再进行解锁
                    this.$emit('addCaseSuccess');
                    return;
                }
                this.$toast.error(res && res.msg || `${isEdit ? '修改' : '上传'}失败，请稍后重试`);
            }).catch(err => {
                this.isSubmit = false;
                this.$normalizeResponseError(err);
            });
        },
        /**
         * 设置editor内容
         * @param {string} content 内容
         */

        setContent(content) {
            this.$nextTick(() => {
                this.$refs.editorItem && this.$refs.editorItem.setContent(content);
            });
        },
        reset() {
            this.formData = {
                // 案例id
                caseId: '',
                // 案例标题
                caseTitle: '',
                // 案例详情
                caseContent: '',
                // 代理法院
                courtName: '',
                // 类型
                type: null,
                // 金额
                money: null,
                // 案例时间
                caseTime: null,
                lawyerName: this.userInfo?.name || ''
            };
        }
    }
};
</script>

<style lang='less' scoped>
.case-edit {
    border-radius: 8px;
    position: relative;
    overflow: hidden;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: rgb(249, 250, 253);

    .header {
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333;
        line-height: 14px;
        display: flex;
        position: relative;
        border-bottom: 1px solid #e9ecf3;
        padding: 24px 24px 25px;
        background: #fff;

        .go-back {
            position: relative;
            padding-left: 20px;
            cursor: pointer;

            &::before {
                height: 16px;
                width: 16px;
                position: absolute;
                content: "";
                left: 0;
                top: -1px;
                background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/repository-manage/left.png") no-repeat center / 100% 100%;
            }
        }

        .line {
            padding: 0 10px;
        }
    }

    .case-detail {
        padding: 24px;
        background: #fff;
        border-radius: 0 0 8px 8px;
        overflow-y: scroll;
        flex: 1;

        .title {
            font-family: PingFang SC;
            font-weight: 600;
            font-size: 18px;
            color: #1e1f24;
            line-height: 18px;
            text-align: left;
        }

        .form {
            .case-content {
                margin-bottom: 0;

                /deep/.veui-field-label {
                    align-self: flex-start !important;
                    padding-top: 10px;

                    &::before {
                        top: 14px !important;
                    }
                }
            }

            /deep/ .veui-field-no-label {
                margin-left: 0;
            }

            /deep/ .veui-field {
                margin-top: 24px;

                .veui-field-label {
                    color: #333;
                    margin-right: 0;
                    justify-content: flex-start;
                    align-self: center;

                    &::before {
                        right: 28px;
                        top: 8px;
                        position: absolute;
                    }
                }

                .veui-input {
                    color: #333;
                    border-radius: 8px;
                    height: 48px;
                }

                .veui-date-picker {
                    border-radius: 8px;
                }

                .veui-date-picker-label {
                    border: none;
                }

                .case-title {
                    width: 640px;
                }

                .case-select {
                    width: 234px;
                    margin-right: 24px;
                }

                .case-money {
                    margin: 0 12px;
                }

                .decs {
                    position: absolute;
                    top: 50px;
                    font-size: 12px;
                    color: #9d9d9d;
                }

                .search-icon {
                    position: absolute;
                    left: 570px;
                }
            }

            /deep/.veui-field-content {
                .veui-field {
                    margin-top: 0;
                }
            }

            .content-detail-box {
                width: 598px;
                height: 251px;
                overflow-y: auto;
                background-color: #f6f7fa;
                padding: 0 0 30px;
                color: #a8b0bf;
            }

            .editor-text-tip {
                position: absolute;
                right: 20px;
                bottom: 10px;

                .error {
                    color: #f5222d;
                }
            }

            /deep/ .ql-editor {
                p img {
                    width: 40%;
                    height: 40%;
                }
            }
        }

        .foot-button {
            display: flex;
            justify-content: center;
            text-align: center;
            align-items: center;

            .btn {
                height: 36px;
                line-height: 36px;
                padding: 0 29px;
                border: 1px solid rgba(56, 85, 213, 1);
                border-radius: 4px;
                color: #3855d5;
                background: #fff;
                cursor: pointer;
            }

            .add-btn {
                background: #3855d5;
                color: #fff;
                margin-left: 12px;
            }
        }

        /deep/.veui-select.veui-select-expanded
        .veui-input {
            border: 1px solid #0052cc;
            box-shadow: 0 0 0 2px rgba(0, 102, 255, 20%);
        }

        /deep/ .case-editor {
            width: 980px;

            .ql-container {
                padding: 0 0 30px;
                width: 100%;
                border-radius: 0 0 8px 8px;
                border-color: #d3d9e6;
            }

            .ql-toolbar {
                border-radius: 8px 8px 0 0;
                border-color: #d3d9e6;
            }
        }
    }

    .case-submit {
        margin-top: 24px;
        background: #fff;
        height: 92px;
        box-shadow: 0 6px 14px 0 rgba(227, 233, 237, .35);
        border-radius: 8px;

        .btn {
            width: 160px;
            height: 44px;
            background: #05f;
            border-radius: 6px;
            margin: 24px;
            font-family: PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #fff;
            line-height: 22px;
            text-align: center;
        }

        .cancel {
            background: #fff;
            color: #05f;
            margin-left: 0;
            border: 1px solid #05f;
        }
    }

    .submit-succ {
        background: #fff;
        height: 400px;
        border-radius: 0 0 8px 8px;
        text-align: center;
        padding-top: 93px;

        .icon {
            width: 92px;
            height: 92px;
            border-radius: 50%;
            margin: 0 auto;
            background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/repository-manage/upload-succ.png") no-repeat center / 100% 100%;
        }

        .content {
            margin-top: 18px;
            text-align: center;
            height: 18px;
            font-family: PingFang SC;
            font-weight: 600;
            font-size: 18px;
            color: #1e1f24;
            line-height: 18px;
        }

        .btns {
            margin-top: 30px;

            .veui-button {
                width: 115px;
                height: 40px;
                background: #fff;
                border-radius: 4px;
                border: 1px solid #05f;
                color: #05f;
                font-family: PingFang SC;
                font-weight: 500;
                font-size: 16px;
            }

            .detail {
                background: #05f;
                border: none;
                color: #fff;
                margin-right: 20px;
            }
        }
    }
}
</style>